<template>
  <div id="transition"></div>
</template>

<style lang="scss" scoped>
#transition {
  background: rgba(0, 0, 0, 0.1);
  height: var(--height);
  left: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  width: 100vw;
  visibility: hidden;
  z-index: layer(cover);
}
</style>
